import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Random anonymous browser id: lets the server count each device once per day per search.
// It is not linked to a name, phone or account.
const AID = "vlx_anon_id";
export function anonId() {
  try {
    let v = localStorage.getItem(AID);
    if (!v) {
      const b = new Uint8Array(16);
      (window.crypto || {}).getRandomValues ? window.crypto.getRandomValues(b) : b.forEach((_, i) => { b[i] = Math.floor(Math.random() * 256); });
      v = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
      localStorage.setItem(AID, v);
    }
    return v;
  } catch { return ""; }
}
api.interceptors.request.use((cfg) => {
  const a = anonId();
  if (a) cfg.headers = { ...(cfg.headers || {}), "X-Anon-Id": a };
  return cfg;
});

export default api;

export async function searchProducts(category, q) {
  const { data } = await api.get(`/products/search`, { params: { category, q, limit: 8 } });
  return data.results || [];
}

// Suggestions plus what the search box should do on Enter / tap outside:
// match "clear" (select choices[0]), "choose" (show choices as big buttons) or "none" (ask Gemini, then manual).
export async function searchMatch(category, q) {
  const { data } = await api.get(`/products/search`, { params: { category, q, limit: 8 } });
  return { results: data.results || [], match: data.match || ((data.results || []).length ? "choose" : "none"),
    choices: data.choices || [], match_count: data.match_count || 0, partial: !!data.partial };
}

export function formatINR(n) {
  return "₹" + Number(n).toLocaleString("en-IN");
}

// ---- anonymous customer key (lets a visitor see their dealer offers without login) ----
const CK = "vlx_customer_key";
export function getCustomerKey() {
  try { return localStorage.getItem(CK) || ""; } catch { return ""; }
}
export function setCustomerKey(k) {
  try { if (k) localStorage.setItem(CK, k); } catch { /* storage blocked */ }
}
export const customerHeaders = () => (getCustomerKey() ? { "X-Customer-Key": getCustomerKey() } : {});

// ---- dealer session ----
const DT = "vlx_dealer_token";
export function getDealerToken() {
  try { return localStorage.getItem(DT) || ""; } catch { return ""; }
}
export function setDealerToken(t) {
  try { if (t) localStorage.setItem(DT, t); else localStorage.removeItem(DT); } catch { /* storage blocked */ }
}
export const dealerHeaders = () => (getDealerToken() ? { Authorization: `Dealer ${getDealerToken()}` } : {});

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return String(d[0].msg).replace(/^Value error, /, "");
  return fallback;
}

// Photos saved in demo mode are served by the backend (/api/uploads/...).
export const mediaUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL || ""}${u}` : u);

// ---- admin session ----
const AT = "vlx_admin_token";
export function getAdminToken() {
  try { return sessionStorage.getItem(AT) || ""; } catch { return ""; }
}
export function setAdminToken(t) {
  try { if (t) sessionStorage.setItem(AT, t); else sessionStorage.removeItem(AT); } catch { /* storage blocked */ }
}
export const adminHeaders = () => (getAdminToken() ? { Authorization: `Admin ${getAdminToken()}` } : {});
